import { render } from "./HomeSelectItem.vue?vue&type=template&id=07905673&scoped=true"
import script from "./HomeSelectItem.vue?vue&type=script&lang=js"
export * from "./HomeSelectItem.vue?vue&type=script&lang=js"

import "./HomeSelectItem.vue?vue&type=style&index=0&id=07905673&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07905673"]])

export default __exports__